module.exports = __webpack_public_path__ + "static/media/wp_video.09c431ca.mp4";